import { hasValue } from '@r-and-a-shared-ui/utils';
import FormField, { FormFieldProps } from '../FormField/FormField';
import styles from './FormDropdownsGroup.module.scss';
import { PPFormFieldProps } from '../FormDropdownPP/FormDropdownPP';
import { useFormContext } from 'react-hook-form';
import {
  formFieldOptionsList,
  PredefinedOptionsList,
} from '../config/form-field-options-lists';
import { OptionProps } from 'react-select';

export const FormDropdownsGroup = (props: PPFormFieldProps) => {
  const { watch } = useFormContext();
  const { uniqueValueSelection, hiddenClearable } = props;

  const getDisabledOptionsValues = (): string[] | undefined => {
    if (!uniqueValueSelection) {
      return [];
    }
    const fieldValues = props.subfields?.map(subfield => {
      const value = watch(subfield.name);
      if (typeof value === 'string') {
        return value;
      }
      return '';
    });
    return fieldValues || [];
  };

  const getOptionsList = (
    fieldProps: FormFieldProps,
  ): OptionProps[] | undefined => {
    if (!fieldProps?.preferredOptionsList) {
      return fieldProps?.options as OptionProps[];
    }
    const fieldOptions =
      formFieldOptionsList[
        fieldProps?.preferredOptionsList as PredefinedOptionsList
      ]();

    return fieldOptions;
  };
  const renderFormFields = (
    fieldsProps: FormFieldProps[] | undefined,
  ): React.JSX.Element[] | null => {
    if (!hasValue(fieldsProps) || typeof fieldsProps === 'undefined') {
      return null;
    }

    return fieldsProps.map(fieldProps => {
      return (
        <FormField
          {...fieldProps}
          key={fieldProps?.key}
          hiddenClearable={hiddenClearable}
          disabledOptionsValues={getDisabledOptionsValues()}
          options={getOptionsList(fieldProps)}
        />
      );
    });
  };

  return (
    <>
      <div id={styles[props.name]} className={styles.label}>
        {props.label}
      </div>
      <div id={styles[props.name]} className={styles['form-dropdowns-grid']}>
        {renderFormFields(props.subfields)}
      </div>
    </>
  );
};
